<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    persistent
    full-width
    width="290px"
    :return-value.sync="date"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          :label="name"
          v-model="formattedDate"
          prepend-icon="mdi-calendar"
          :error-messages="errorMessages"
          readonly
        />
      </template>
      <v-date-picker
        v-model="date"
        scrollable
        locale="de-de"
      >
        <v-spacer />
        <v-btn text color="primary" @click="dateSelected(null)">Abbrechen</v-btn>
        <v-btn text color="primary" @click="dateSelected(date)">Bestätigen</v-btn>
      </v-date-picker>
    </v-dialog>
</template>

<script>

import moment from 'moment';

export default {
  name: 'DateMetadata',
  props: {
    name: {
      type: String,
      mandatory: true,
    },
    value: {
    },
    mandatory: {
      type: Boolean,
      mandatory: true,
    },
  },
  components: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    errorMessages() {
      if (!this.mandatory) {
        return null;
      }

      return !this.value ? 'Pflichfeld' : null;
    },
    formattedDate() {
      return this.date ? moment(this.date).format('DD.MM.YYYY') : '';
    }
  },
  methods: {
    dateSelected(date) {
      this.$refs.dialog.save(date);

      if (!date) {
        this.$emit('input', null);
      } else {
        const utc = moment(date).utc().format();
        this.$emit('input', utc);
      }
    },
    getInitialDateValue() {
      if (!this.value || moment.isMoment(this.value)) {
        return null;
      }

      return moment(this.value).format('YYYY-MM-DD');
    },
  },
  data() {
    return {
      modal: false,
      date: this.getInitialDateValue(),
    };
  },
};
</script>
